import Modal from 'react-modal'
import styles from './index.module.scss'
import CloseSVG from './close.svg'
import cn from 'classnames'

export default function CustomModal({ children, className, closeElement, modalIsOpen, setModalIsOpen }) {

    return (
        <Modal
            className={cn(styles.modal, className)}
            overlayClassName={styles.overlay}
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
        >
            {/**<button onClick={() => setModalIsOpen(false)} className={styles.close}>X</button>*/}
            {children}
        </Modal>
    )

}